
        <div class="backdrop"
             [ngStyle]="{'background-color': config.backdropColor, 'border-radius': config.backdropBorderRadius}"></div>

        <div class="wrapper"
             [ngClass]="[config.spinnerPosition, config.spinnerSize]"
             [ngStyle]="{'color': config.spinnerColor, 'font-size': config.spinnerFontSize}">
            <ng-container *ngIf="!template">
                <!-- DUAL CIRCLE SPINNER -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.dualCircle"
                     class="dual-circle"></div>


                <!-- SCALING BARS -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.scalingBars"
                     class="scaling-bars"></div>


                <!-- CHASING DOTS -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.chasingDots"
                     class="chasing-dots"></div>


                <!-- BOUNCING DOTS -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.bouncingDots"
                     class="bouncing-dots">
                    <div class="bounce-1"></div>
                    <div class="bounce-2"></div>
                    <div class="bounce-3"></div>
                </div>


                <!-- FADING CIRCLE -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.fadingCircle"
                     class="fading-circle">
                    <div class="sk-circle1 sk-circle"></div>
                    <div class="sk-circle2 sk-circle"></div>
                    <div class="sk-circle3 sk-circle"></div>
                    <div class="sk-circle4 sk-circle"></div>
                    <div class="sk-circle5 sk-circle"></div>
                    <div class="sk-circle6 sk-circle"></div>
                    <div class="sk-circle7 sk-circle"></div>
                    <div class="sk-circle8 sk-circle"></div>
                    <div class="sk-circle9 sk-circle"></div>
                    <div class="sk-circle10 sk-circle"></div>
                    <div class="sk-circle11 sk-circle"></div>
                    <div class="sk-circle12 sk-circle"></div>
                </div>

                <!-- HALF CIRCLE -->
                <div *ngIf="config?.animationType === ANIMATION_TYPES.halfCircle" class="half-circle"></div>

                <!-- CUBIC GRID -->
                <div class="sk-cube-grid cube-grid" *ngIf="config?.animationType === ANIMATION_TYPES.cubeGrid">
                    <div class="sk-cube sk-cube1"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube2"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube3"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube4"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube5"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube6"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube7"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube8"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                    <div class="sk-cube sk-cube9"
                         [ngStyle]="{'background-color': config?.spinnerColor}"></div>
                </div>
            </ng-container>

            <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
    